import { Check, Icon as PhosphorIconType, WarningCircle } from '@phosphor-icons/react';
// types
import { MessageTypes } from 'types/flashMessage';
import { COLORS } from './styles';

export const FLASH_MESSAGE_ICONS: Record<MessageTypes, PhosphorIconType> = {
  success: Check,
  error: WarningCircle,
  info: WarningCircle,
};

export const FLASH_MESSAGE_COLORS: Record<MessageTypes, string> = {
  success: COLORS.SUCCESS,
  error: COLORS.DANGER,
  info: COLORS.INFO,
};

export const FLASH_MESSAGE_TEXTS: Record<string, string> = {
  previewInfo:
    '診断画面のプレビューを表示しています。回答を行っても反映されません。\n' +
    '回答時にこちらのメッセージが表示されている場合は管理者へお問い合わせください。',
};
